import { useEffect, useRef } from "react";
import { WidgetInstance } from "friendly-challenge";

const FriendlyCaptcha = ({siteKey, cb}) => {
    const container = useRef(null);
    const widget = useRef(null);

    const doneCallback = async (solution) => {
        const result = await fetch("/umbraco/api/FriendlyCaptcha/Validate", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(solution),
        })
        const ok = await result.json()
        cb(ok === true)
    };

    const errorCallback = (err) => {
        cb(false)
    };

    useEffect(() => {
        if (!widget.current && container.current) {
            widget.current = new WidgetInstance(container.current, {
                startMode: "manual",
                doneCallback: doneCallback,
                errorCallback: errorCallback,
            });
        }

        return () => {
            if (widget.current !== undefined) widget.current.reset();
        };
    }, [container]);

    return <div ref={container} className="frc-captcha" data-sitekey={siteKey} />;
};

export default FriendlyCaptcha;